<template>
  <b-row>
    <b-col cols="12">
      <div class="d-flex kpi-row" style="gap: 16px">
        <b-card
          style="
            background: linear-gradient(rgb(236, 253, 245), rgb(255, 255, 255));
            border-left: 4px solid rgb(16, 185, 129);
          "
        >
          <div class="card-title mb-1 text-muted">
            <feather-icon icon="DollarSignIcon" />Turnover
          </div>
          <h3 class="font-weight-bolder">
            ${{ formatNumber(statistics.turnover.value || 0) }}
          </h3>
          <p class="mb-0 text-muted">
            Split: Resulted {{ statistics.turnover.splitResultedPct || 0 }}% /
            Unresulted {{ statistics.turnover.splitUnresultedPct || 0 }}%
          </p>
        </b-card>
        <b-card
          style="
            border-left: 4px solid rgb(16, 185, 129);
            background: linear-gradient(rgb(236, 253, 245), rgb(255, 255, 255));
          "
        >
          <div class="card-title mb-1 text-muted">
            <BIconGraphUp scale="0.8" /> GGR
          </div>
          <h3 class="font-weight-bolder">
            ${{ formatNumber(statistics.ggr.value || 0) }}
          </h3>
          <!-- <p class="mb-0 text-success">
              {{ statistics.grr.vsLastPeriodPct || 0 }}% vs last week
            </p> -->
        </b-card>
        <b-card
          style="
            border-left: 4px solid rgb(20, 184, 166);
            background: linear-gradient(rgb(240, 253, 250), rgb(255, 255, 255));
          "
        >
          <div class="card-title mb-1 text-muted">
            <feather-icon icon="DollarSignIcon" /> NGR
          </div>
          <h3 class="font-weight-bolder">
            ${{ formatNumber(statistics.ngr.value || 0) }}
          </h3>
        </b-card>
        <b-card
          style="
            border-left: 4px solid rgb(99, 102, 241);
            background: linear-gradient(rgb(238, 242, 255), rgb(255, 255, 255));
          "
        >
          <div class="card-title mb-1 text-muted">
            <feather-icon icon="DollarSignIcon" /> Cash in Bank
          </div>
          <h3 class="font-weight-bolder">
            ${{ formatNumber(statistics.cashInBank.value || 0) }}
          </h3>
          <div class="mb-0 text-muted">
            {{ statistics.cashInBank.deltaTodayPct }}% today
          </div>
        </b-card>
        <b-card
          style="
            border-left: 4px solid rgb(239, 68, 68);
            background: linear-gradient(rgb(254, 242, 242), rgb(255, 255, 255));
          "
        >
          <div class="card-title mb-1 text-muted">GGR Split: Bonus vs Cash</div>
          <h3 class="font-weight-bolder">
            {{ statistics.ggrSplitBonusVsCash.bonusPct || 0 }}% / Cash
            {{ statistics.ggrSplitBonusVsCash.cashPct || 0 }}%
          </h3>
          <p class="mb-0 text-success">
            Margin on cash higher by
            {{ statistics.ggrSplitBonusVsCash.cashMarginDeltaPp || 0 }}pp
          </p>
        </b-card>
        <b-card
          style="
            border-left: 4px solid rgb(6, 182, 212);
            background: linear-gradient(rgb(236, 254, 255), rgb(255, 255, 255));
          "
        >
          <div class="card-title mb-1 text-muted">
            Bet Split: Racing vs Sport
          </div>
          <h3 class="font-weight-bolder">
            {{ statistics.betSplitRacingVsSport.racingPct || 0 }}% /
            {{ statistics.betSplitRacingVsSport.sportPct || 0 }}%
          </h3>
        </b-card>
        <b-card
          style="
            border-left: 4px solid rgb(139, 92, 246);
            background: linear-gradient(rgb(245, 243, 255), rgb(255, 255, 255));
          "
        >
          <div class="card-title mb-1 text-muted">Bet Type Split</div>
          <h3 class="font-weight-bolder" style="word-break: break-word">
            Singles {{ statistics.betTypeSplit.singlePct || 0 }}% / Multi
            {{ statistics.betTypeSplit.multiPct || 0 }}% / Exotics
            {{ statistics.betTypeSplit.exoticPct || 0 }}%
          </h3>
        </b-card>
      </div>
    </b-col>
    <b-col cols="12">
      <b-row>
        <b-col cols="6" md="4" lg="2">
          <b-card
            style="
              border-left: 4px solid rgb(59, 130, 246);
              background: linear-gradient(
                rgb(239, 246, 255),
                rgb(255, 255, 255)
              );
            "
          >
            <div class="card-title mb-1 text-muted">
              <i class="fa fa-users"></i> Active Clients
            </div>
            <h3 class="font-weight-bolder">
              {{ formatNumber(statistics.activeClients.value || 0) }}
            </h3>
            <!-- <p class="mb-0 text-success">
              {{ statistics.activeClients.vsLastPeriodPct || 0 }}% vs last week
            </p> -->
          </b-card>
        </b-col>
        <b-col cols="6" md="4" lg="2">
          <b-card
            style="
              border-left: 4px solid rgb(16, 185, 129);
              background: linear-gradient(
                rgb(236, 253, 245),
                rgb(255, 255, 255)
              );
            "
          >
            <div class="card-title mb-1 text-muted">
              <i class="fa fa-user-plus"></i> New Signups This Month
            </div>
            <h3 class="font-weight-bolder">
              {{ statistics.newSignupsThisMonth.value }}
            </h3>
            <!-- <p class="mb-0 text-success">
              {{ statistics.newSignupsThisMonth.vsLastPeriodPct || 0 }}% vs last
              month
            </p> -->
          </b-card>
        </b-col>
        <b-col cols="6" md="4" lg="2">
          <b-card
            style="
              border-left: 4px solid rgb(239, 68, 68);
              background: linear-gradient(
                rgb(254, 242, 242),
                rgb(255, 255, 255)
              );
            "
          >
            <div class="card-title mb-1 text-muted">Closed Accounts</div>
            <h3 class="font-weight-bolder">
              {{ statistics.closedAccounts.count || 0 }}
            </h3>
            <p class="mb-0 text-muted">This month</p>
          </b-card>
        </b-col>
        <b-col cols="6" md="4" lg="2">
          <b-card
            style="
              border-left: 4px solid rgb(132, 204, 22);
              background: linear-gradient(
                rgb(247, 254, 231),
                rgb(255, 255, 255)
              );
            "
          >
            <div class="card-title mb-1 text-muted">Unsettled Bets</div>
            <h3 class="font-weight-bolder">
              {{ statistics.unsettledBets.count || 0 }}
            </h3>
          </b-card>
        </b-col>
        <b-col cols="6" md="4" lg="2">
          <b-card
            style="
              border-left: 4px solid rgb(245, 158, 11);
              background: linear-gradient(
                rgb(255, 251, 235),
                rgb(255, 255, 255)
              );
            "
          >
            <div class="card-title mb-1 text-muted">Betstop</div>
            <h3 class="font-weight-bolder">
              {{ statistics.betstop.count || 0 }}
            </h3>
            <p class="mb-0 text-muted">This month</p>
          </b-card>
        </b-col>
        <b-col cols="6" md="4" lg="2">
          <b-card
            style="
              border-left: 4px solid rgb(16, 185, 129);
              background: linear-gradient(
                rgb(236, 253, 245),
                rgb(255, 255, 255)
              );
            "
          >
            <div class="card-title mb-1 text-muted">Affiliate NGR Payouts</div>
            <h3 class="font-weight-bolder">
              ${{ formatNumber(statistics.affiliateNgrPayouts.value || 0) }}
            </h3>
            <p class="mb-0 text-muted">Month-to-date</p>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="12">
      <b-row>
        <b-col cols="6" md="4" lg="2">
          <b-card
            style="
              border-left: 4px solid rgb(59, 130, 246);
              background: linear-gradient(
                rgb(239, 246, 255),
                rgb(255, 255, 255)
              );
            "
          >
            <div
              class="text-center font-weight-bolder mb-2"
              style="font-size: 1rem"
            >
              YTD Revenue
            </div>
            <div class="d-flex justify-content-around mb-2">
              <div class="text-center">
                <div class="small text-muted" style="font-size: 0.75rem">
                  Budget
                </div>
                <div class="font-weight-bolder" style="font-size: 0.8rem">
                  ${{ formatNumber(statistics.ytdRevenue.budget || 0) }}
                </div>
              </div>
              <div class="text-center">
                <div class="small text-muted" style="font-size: 0.75rem">
                  Variance
                </div>
                <div
                  class="font-weight-bolder text-danger"
                  style="font-size: 0.8rem"
                >
                  {{ statistics.ytdRevenue.variancePct || 0 }}%
                </div>
              </div>
            </div>
            <div
              class="text-center font-weight-bolder mb-2"
              style="font-size: 1.5rem; color: #000"
            >
              ${{ formatNumber(statistics.ytdRevenue.value || 0) }}
            </div>
            <div class="mb-2" style="height: 15px; display: flex; gap: 2px">
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 50%"></div>
              <div style="flex: 1; background: #1f2937; height: 30%"></div>
            </div>
          </b-card>
        </b-col>
        <b-col cols="6" md="4" lg="2">
          <b-card
            style="
              border-left: 4px solid rgb(59, 130, 246);
              background: linear-gradient(
                rgb(239, 246, 255),
                rgb(255, 255, 255)
              );
            "
          >
            <div
              class="text-center font-weight-bolder mb-2"
              style="font-size: 1rem"
            >
              YTD Turnover
            </div>
            <div class="d-flex justify-content-around mb-2">
              <div class="text-center">
                <div class="small text-muted" style="font-size: 0.75rem">
                  Budget
                </div>
                <div class="font-weight-bolder" style="font-size: 0.8rem">
                  ${{ formatNumber(statistics.ytdTurnover.budget || 0) }}
                </div>
              </div>
              <div class="text-center">
                <div class="small text-muted" style="font-size: 0.75rem">
                  Variance
                </div>
                <div
                  class="font-weight-bolder text-success"
                  style="font-size: 0.8rem"
                >
                  {{ statistics.ytdTurnover.variancePct || 0 }}%
                </div>
              </div>
            </div>
            <div
              class="text-center font-weight-bolder mb-2"
              style="font-size: 1.5rem; color: #000"
            >
              ${{ formatNumber(statistics.ytdTurnover.value || 0) }}
            </div>
            <div class="mb-2" style="height: 15px; display: flex; gap: 2px">
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 80%"></div>
              <div style="flex: 1; background: #1f2937; height: 60%"></div>
              <div style="flex: 1; background: #1f2937; height: 40%"></div>
            </div>
          </b-card>
        </b-col>
        <b-col cols="6" md="4" lg="2">
          <b-card
            style="
              border-left: 4px solid rgb(59, 130, 246);
              background: linear-gradient(
                rgb(239, 246, 255),
                rgb(255, 255, 255)
              );
            "
          >
            <div
              class="text-center font-weight-bolder mb-2"
              style="font-size: 1rem"
            >
              YTD Yield
            </div>
            <div class="d-flex justify-content-around mb-2">
              <div class="text-center">
                <div class="small text-muted" style="font-size: 0.75rem">
                  Budget
                </div>
                <div class="font-weight-bolder" style="font-size: 0.8rem">
                  {{ statistics.ytdYield.budget }}%
                </div>
              </div>
              <div class="text-center">
                <div class="small text-muted" style="font-size: 0.75rem">
                  Variance
                </div>
                <div
                  class="font-weight-bolder text-success"
                  style="font-size: 0.8rem"
                >
                  {{ statistics.ytdYield.variancePct || 0 }}%
                </div>
              </div>
            </div>
            <div
              class="text-center font-weight-bolder mb-2"
              style="font-size: 1.5rem; color: #000"
            >
              {{ statistics.ytdYield.value || 0 }}%
            </div>
            <div class="mb-2" style="height: 15px; display: flex; gap: 2px">
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 70%"></div>
            </div>
          </b-card>
        </b-col>
        <b-col cols="6" md="4" lg="2">
          <b-card
            style="
              border-left: 4px solid rgb(16, 185, 129);
              background: linear-gradient(
                rgb(236, 253, 245),
                rgb(255, 255, 255)
              );
            "
          >
            <div
              class="text-center font-weight-bolder mb-2"
              style="font-size: 1rem"
            >
              WTD Revenue
            </div>
            <div class="d-flex justify-content-around mb-2">
              <div class="text-center">
                <div class="small text-muted" style="font-size: 0.75rem">
                  Budget
                </div>
                <div class="font-weight-bolder" style="font-size: 0.8rem">
                  ${{ formatNumber(statistics.wtdRevenue.budget || 0) }}
                </div>
              </div>
              <div class="text-center">
                <div class="small text-muted" style="font-size: 0.75rem">
                  Variance
                </div>
                <div
                  class="font-weight-bolder text-danger"
                  style="font-size: 0.8rem"
                >
                  {{ statistics.wtdRevenue.variancePct || 0 || 0 }}%
                </div>
              </div>
            </div>
            <div
              class="text-center font-weight-bolder mb-2"
              style="font-size: 1.5rem; color: #000"
            >
              ${{ formatNumber(statistics.wtdRevenue.value || 0) }}
            </div>
            <div class="mb-2" style="height: 15px; display: flex; gap: 2px">
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 30%"></div>
              <div style="flex: 1; background: #1f2937; height: 20%"></div>
              <div style="flex: 1; background: #1f2937; height: 50%"></div>
              <div style="flex: 1; background: #1f2937; height: 40%"></div>
              <div style="flex: 1; background: #1f2937; height: 30%"></div>
              <div style="flex: 1; background: #1f2937; height: 60%"></div>
              <div style="flex: 1; background: #1f2937; height: 35%"></div>
              <div style="flex: 1; background: #1f2937; height: 25%"></div>
              <div style="flex: 1; background: #1f2937; height: 45%"></div>
            </div>
          </b-card>
        </b-col>
        <b-col cols="6" md="4" lg="2">
          <b-card
            style="
              border-left: 4px solid rgb(16, 185, 129);
              background: linear-gradient(
                rgb(236, 253, 245),
                rgb(255, 255, 255)
              );
            "
          >
            <div
              class="text-center font-weight-bolder mb-2"
              style="font-size: 1rem"
            >
              WTD Turnover
            </div>
            <div class="d-flex justify-content-around mb-2">
              <div class="text-center">
                <div class="small text-muted" style="font-size: 0.75rem">
                  Budget
                </div>
                <div class="font-weight-bolder" style="font-size: 0.8rem">
                  ${{ formatNumber(statistics.wtdTurnover.budget || 0) }}
                </div>
              </div>
              <div class="text-center">
                <div class="small text-muted" style="font-size: 0.75rem">
                  Variance
                </div>
                <div
                  class="font-weight-bolder text-danger"
                  style="font-size: 0.8rem"
                >
                  {{ statistics.wtdTurnover.variancePct || 0 }}%
                </div>
              </div>
            </div>
            <div
              class="text-center font-weight-bolder mb-2"
              style="font-size: 1.5rem; color: #000"
            >
              ${{ formatNumber(statistics.wtdTurnover.value || 0) }}
            </div>
            <div class="mb-2" style="height: 15px; display: flex; gap: 2px">
              <div style="flex: 1; background: #1f2937; height: 40%"></div>
              <div style="flex: 1; background: #1f2937; height: 30%"></div>
              <div style="flex: 1; background: #1f2937; height: 50%"></div>
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 70%"></div>
              <div style="flex: 1; background: #1f2937; height: 60%"></div>
              <div style="flex: 1; background: #1f2937; height: 80%"></div>
              <div style="flex: 1; background: #1f2937; height: 90%"></div>
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 85%"></div>
            </div>
          </b-card>
        </b-col>
        <b-col cols="6" md="4" lg="2">
          <b-card
            style="
              border-left: 4px solid rgb(16, 185, 129);
              background: linear-gradient(
                rgb(236, 253, 245),
                rgb(255, 255, 255)
              );
            "
          >
            <div
              class="text-center font-weight-bolder mb-2"
              style="font-size: 1rem"
            >
              WTD Yield
            </div>
            <div class="d-flex justify-content-around mb-2">
              <div class="text-center">
                <div class="small text-muted" style="font-size: 0.75rem">
                  Budget
                </div>
                <div class="font-weight-bolder" style="font-size: 0.8rem">
                  {{ statistics.wtdYield.budget }}%
                </div>
              </div>
              <div class="text-center">
                <div class="small text-muted" style="font-size: 0.75rem">
                  Variance
                </div>
                <div
                  class="font-weight-bolder text-danger"
                  style="font-size: 0.8rem"
                >
                  {{ statistics.wtdYield.variancePct || 0 }}%
                </div>
              </div>
            </div>
            <div
              class="text-center font-weight-bolder mb-2"
              style="font-size: 1.5rem; color: #000"
            >
              {{ statistics.wtdYield.value || 0 }}%
            </div>
            <div class="mb-2" style="height: 15px; display: flex; gap: 2px">
              <div style="flex: 1; background: #1f2937; height: 50%"></div>
              <div style="flex: 1; background: #1f2937; height: 30%"></div>
              <div style="flex: 1; background: #1f2937; height: 100%"></div>
              <div style="flex: 1; background: #1f2937; height: 40%"></div>
              <div style="flex: 1; background: #1f2937; height: 60%"></div>
              <div style="flex: 1; background: #1f2937; height: 35%"></div>
              <div style="flex: 1; background: #1f2937; height: 70%"></div>
              <div style="flex: 1; background: #1f2937; height: 45%"></div>
              <div style="flex: 1; background: #1f2937; height: 55%"></div>
              <div style="flex: 1; background: #1f2937; height: 80%"></div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>

    <b-col cols="12">
      <b-card
        style="
          border-left: 4px solid rgb(139, 92, 246);
          background: linear-gradient(rgb(245, 243, 255), rgb(255, 255, 255));
        "
      >
        <div class="font-weight-bolder mb-1" style="font-size: 1.1rem">
          Racing Overview
        </div>
        <div
          class="d-flex justify-content-between align-items-center flex-wrap"
          style="gap: 1rem"
        >
          <div class="text-center">
            <p class="mb-0 text-muted">Settled Total Bets</p>
            <div class="font-weight-bolder" style="font-size: 1.3rem">
              {{ racingOverview.settledTotalBets }}
            </div>
          </div>
          <div class="text-center">
            <p class="mb-0 text-muted">Settled Bets</p>
            <div class="font-weight-bolder" style="font-size: 1.3rem">
              {{ racingOverview.settledBets }}
            </div>
          </div>
          <div class="text-center">
            <p class="mb-0 text-muted">Settled Bonus Bets</p>
            <div class="font-weight-bolder" style="font-size: 1.3rem">
              {{ racingOverview.settledBonusBets }}
            </div>
          </div>
          <div class="text-center">
            <p class="mb-0 text-muted">Rejected Bets</p>
            <div class="font-weight-bolder" style="font-size: 1.3rem">
              {{ racingOverview.rejectedBets }}
            </div>
          </div>
          <div class="text-center">
            <p class="mb-0 text-muted">Unsettled Bets</p>
            <div class="font-weight-bolder" style="font-size: 1.3rem">
              {{ racingOverview.unsettledBets }}
            </div>
          </div>
          <div class="text-center">
            <p class="mb-0 text-muted">Unsettled Bonus Bets</p>
            <div class="font-weight-bolder" style="font-size: 1.3rem">
              {{ racingOverview.unsettledBonusBets }}
            </div>
          </div>
          <div class="text-center">
            <p class="mb-0 text-muted">Unsettled Amount</p>
            <div class="font-weight-bolder" style="font-size: 1.3rem">
              {{ racingOverview.unsettledAmount }}
            </div>
          </div>
          <div class="text-center">
            <p class="mb-0 text-muted">Unsettled Bonus Amount</p>
            <div class="font-weight-bolder" style="font-size: 1.3rem">
              {{ racingOverview.unsettledBonusAmount }}
            </div>
          </div>
          <div class="text-center">
            <p class="mb-0 text-muted">Bets Stake</p>
            <div class="font-weight-bolder" style="font-size: 1.3rem">
              {{ racingOverview.betsStake }}
            </div>
          </div>
          <div class="text-center">
            <p class="mb-0 text-muted">Bonus Result</p>
            <div class="font-weight-bolder" style="font-size: 1.3rem">
              {{ racingOverview.bonusResult }}
            </div>
          </div>
        </div>
      </b-card>
    </b-col>
    <b-col cols="12">
      <b-card
        class="dashboard-card mb-4"
        style="
          border-left: 4px solid rgb(6, 182, 212);
          background: linear-gradient(rgb(236, 254, 255), rgb(255, 255, 255));
        "
      >
        <div class="font-weight-bolder mb-1" style="font-size: 1.1rem">
          Sports Overview
        </div>
        <div
          class="d-flex justify-content-between align-items-center flex-wrap"
          style="gap: 1rem"
        >
          <div class="text-center">
            <p class="mb-0 text-muted">Settled Total Bets</p>
            <div class="font-weight-bolder" style="font-size: 1.3rem">
              {{ sportOverview.settledTotalBets }}
            </div>
          </div>
          <div class="text-center">
            <p class="mb-0 text-muted">Settled Bets</p>
            <div class="font-weight-bolder" style="font-size: 1.3rem">
              {{ sportOverview.settledBets }}
            </div>
          </div>
          <div class="text-center">
            <p class="mb-0 text-muted">Settled Bonus Bets</p>
            <div class="font-weight-bolder" style="font-size: 1.3rem">
              {{ sportOverview.settledBonusBets }}
            </div>
          </div>
          <div class="text-center">
            <p class="mb-0 text-muted">Rejected Bets</p>
            <div class="font-weight-bolder" style="font-size: 1.3rem">
              {{ sportOverview.rejectedBets }}
            </div>
          </div>
          <div class="text-center">
            <p class="mb-0 text-muted">Unsettled Bets</p>
            <div class="font-weight-bolder" style="font-size: 1.3rem">
              {{ sportOverview.unsettledBets }}
            </div>
          </div>
          <div class="text-center">
            <p class="mb-0 text-muted">Unsettled Bonus Bets</p>
            <div class="font-weight-bolder" style="font-size: 1.3rem">
              {{ sportOverview.unsettledBonusBets }}
            </div>
          </div>
          <div class="text-center">
            <p class="mb-0 text-muted">Unsettled Amount</p>
            <div class="font-weight-bolder" style="font-size: 1.3rem">
              {{ sportOverview.unsettledAmount }}
            </div>
          </div>
          <div class="text-center">
            <p class="mb-0 text-muted">Unsettled Bonus Amount</p>
            <div class="font-weight-bolder" style="font-size: 1.3rem">
              {{ sportOverview.unsettledBonusAmount }}
            </div>
          </div>
          <div class="text-center">
            <p class="mb-0 text-muted">Bets Stake</p>
            <div class="font-weight-bolder" style="font-size: 1.3rem">
              {{ sportOverview.betsStake }}
            </div>
          </div>
          <div class="text-center">
            <p class="mb-0 text-muted">Bonus Result</p>
            <div class="font-weight-bolder" style="font-size: 1.3rem">
              {{ sportOverview.bonusResult }}
            </div>
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardHeader,
  BCol,
  BRow,
  BProgress,
  BIconWallet,
  BIconCash,
  BProgressBar,
  BIconTrophy,
  BIconCalculator,
  BIcon,
  BIconGraphUp,
} from "bootstrap-vue";
import { objectProp } from "@/helpers/props";

export default {
  props: {
    statistics: objectProp(),
    racingOverview: objectProp(),
    sportOverview: objectProp(),
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardHeader,
    BProgress,
    BIconWallet,
    BIconCash,
    BProgressBar,
    BIconTrophy,
    BIcon,
    BIconCalculator,
    BIconGraphUp,
  },
  data() {
    return {};
  },
  methods: {
    formatNumber(value) {
      if (value === null || value === undefined) return "-";
      const absValue = Math.abs(value);
      const sign = value < 0 ? "-" : "";
      if (absValue >= 1000000) {
        return (
          sign + (absValue / 1000000).toFixed(2).replace(/\.00$/, "") + "M"
        );
      }
      if (absValue >= 1000) {
        return sign + (absValue / 1000).toFixed(2).replace(/\.00$/, "") + "K";
      }
      return sign + absValue.toString();
    },
  },
};
</script>
<style lang="scss" scoped>
.kpi-row {
  flex-wrap: wrap;
  > .card {
    @media (min-width: 1024px) {
      flex: 1 1 0;
    }
  }
  @media (min-width: 1024px) {
    flex-wrap: nowrap !important;
  }
}
.card-custom {
  width: 100%;
  background: var(--bg-color);
  border: 1px solid var(--border-color);
  border-left: 4px solid var(--border-color);
  padding: 14px;
  border-radius: 12px;
  small {
    color: var(--border-color);
  }
}
.circle-progress {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  position: relative;
  border: 5px solid;
  border-color: #00bc7d #a4f4cf #00bc7d #00bc7d;
  position: relative;
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.status-progress {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  position: relative;
  border: 5px solid;
  border-color: #00bc7d #a4f4cf #00bc7d #00bc7d;
  position: relative;
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  animation: pulse 2s infinite ease-in-out;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 0.3;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.3);
  }
}
</style>
